import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'

import { fetchOnlineSales } from '../actions/sales'
import { fetchMachines } from '../actions/machines'
import { fetchCustomers } from '../actions/customers'

import { renderInputField, renderSelectField } from '../utils/forms'

class OnlineSalesFilterForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false }

    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { role, fetchMachines, fetchCustomers } = this.props

    fetchMachines()

    if (role === 'ADMIN') {
      fetchCustomers()
    }

    this.load(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  load(props) {
    const { role, machines, customers, sales } = props

    if (!sales.loading && sales.salesNeedRefresh) {
      this.submit(this.props.formValues)
    }

    if (!this.state.loaded && machines && (role !== 'ADMIN' || customers)) {
      this.setState({ loaded: true })
    }
  }

  submit(props) {
    return this.props.fetchOnlineSales(props.machine, props.customer, props.StartDate, props.EndDate)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  render() {
    const { loaded } = this.state
    const { error, submitting, handleSubmit, machines, customers, role } = this.props

    if (!loaded) {
      return (
        <LoadingProgress />
      )
    }

    return (
      <form onSubmit={handleSubmit(this.submit)} className="mb-3">
        <div className="row">
          <div className="col col-12 col-lg-6">
            <Field name="plataforma"
                   component={renderSelectField}
                   label="Plataforma">
              <option value="">Todas</option>
              <option value="pacommunity">PA Community</option>
            </Field>
            { role === 'ADMIN' &&
            <Field name="customer"
                   component={renderSelectField}
                   label="Cliente">
              <option value="">Todos</option>
              {customers && customers.filter(x => x).map(customer => {
                return (
                  <option value={customer._id} key={customer._id}>
                    {customer.Fullname}
                  </option>
                )
              })}
            </Field>
            }
          </div>
          <div className="col col-12 col-lg-6">
            <Field name="StartDate"
                   component={renderInputField}
                   type="date"
                   label="Fecha inicio"/>
            <Field name="EndDate"
                   component={renderInputField}
                   type="date"
                   label="Fecha fin"/>
          </div>
        </div>
        <div className="form-row">
          { error && <div className="alert alert-danger">{error}</div> }
        </div>
        <div className="form-row">
          <button className="btn bg-vw-dark text-white mr-1 button-center"
                  type="submit"
                  disabled={submitting}>
            <i className="fas fa-sync mr-1"></i>Actualizar
          </button>
        </div>
      </form>
    )


  }
}

OnlineSalesFilterForm = reduxForm({
  form: 'OnlineSalesFilterForm',
})(OnlineSalesFilterForm)

const selector = formValueSelector('OnlineSalesFilterForm')

const mapStateToProps = state => ({
  machines: state.machines.machines,
  customers: state.customers.customers,
  sales: state.sales,
  role: state.auth.role,
  initialValues: {
    machine: '',
    customer: '',
    StartDate: new Date().toISOString().substring(0, 10),
    EndDate: new Date().toISOString().substring(0, 10)
  },
  formValues: {
    machine: selector(state, 'machine'),
    customer: selector(state, 'customer'),
    StartDate: selector(state, 'StartDate'),
    EndDate: selector(state, 'EndDate')
  }
})

const mapDispatchToProps = dispatch => ({
  fetchOnlineSales: bindActionCreators(fetchOnlineSales, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(OnlineSalesFilterForm)
